import React, { useEffect, useRef, useState } from 'react';
import './Services.css';

const Services = () => {
  const leftCardRef = useRef();
  const rightCardRef = useRef();
  const [leftVisible, setLeftVisible] = useState(false);
  const [rightVisible, setRightVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setLeftVisible(entry.isIntersecting),
      { threshold: 0.3 }
    );
    if (leftCardRef.current) observer.observe(leftCardRef.current);
    return () => {
      if (leftCardRef.current) observer.unobserve(leftCardRef.current);
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setRightVisible(entry.isIntersecting),
      { threshold: 0.3 }
    );
    if (rightCardRef.current) observer.observe(rightCardRef.current);
    return () => {
      if (rightCardRef.current) observer.unobserve(rightCardRef.current);
    };
  }, []);

  return (
    <section id="services">
      <div className="container">
        <h2 className="mb-4">Nuestros servicios</h2>
        <div className="row">
          <div className="col-lg-6 mb-4">
            <div
              ref={leftCardRef}
              className={`card h-100 animate-from-left ${leftVisible ? 'visible' : ''}`}
            >
              <div className="row g-0 flex-column flex-lg-row h-100">
                <div className="col-12 col-lg-4">
                  <img
                    src="https://plnyywoflfpepjcggdms.supabase.co/storage/v1/object/public/images/services/20210205_111705.jpg"
                    className="img-fluid rounded-start w-100 h-100"
                    alt="Renta de sanitarios portátiles"
                    style={{ objectFit: 'cover' }}
                  />
                </div>
                <div className="col-12 col-lg-8 d-flex">
                  <div className="card-body d-flex flex-column">
                    <h5 className="card-title">Renta de sanitarios portátiles</h5>
                    <p className="card-text" style={{ textAlign: 'justify' }}>Nuestros sanitarios están equipados con todo lo necesario para asegurar la mejor experiencia para tus invitados o trabajadores. Ofrecemos opciones flexibles de renta y entrega puntual.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 mb-4">
            <div
              ref={rightCardRef}
              className={`card h-100 animate-from-right ${rightVisible ? 'visible' : ''}`}
            >
              <div className="row g-0 flex-column flex-lg-row h-100">
                <div className="col-12 col-lg-4">
                  <img
                    src="https://plnyywoflfpepjcggdms.supabase.co/storage/v1/object/public/images/services/IMG_%2020250210_172516.jpg"
                    className="img-fluid rounded-start w-100 h-100"
                    alt="Limpieza de fosas sépticas"
                    style={{ objectFit: 'cover' }}
                  />
                </div>
                <div className="col-12 col-lg-8 d-flex">
                  <div className="card-body d-flex flex-column">
                    <h5 className="card-title">Limpieza de fosas sépticas</h5>
                    <p className="card-text" style={{ textAlign: 'justify' }}> Nuestro equipo de expertos se encarga de la limpieza y mantenimiento de fosas sépticas de manera rápida y eficiente, utilizando equipo de última generación para garantizar un trabajo impecable.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
